
<template>
    <div :class="{ 'navbar-brand': false }">

    <div>        
        <div class="main-content" :style="{
                    marginTop: '-100px',
                    marginLeft: '40px',
                    marginRight: '40px',
                    fontFamily: selectedFont ? selectedFont.name : 'Sofia'
                    }">
            <div >
                <!-- <div v-if=showSidebar class="side-panel">
                    <span class="text-container">
                            <i id="close-sidebar" class="bx bx-md  bx-x" @click="toggleSidebar"></i>      
                    </span>
                    
                    <div style="text-align: left; ">
                        <hr class="theme-separator">
                            <ul>
                                <li>
                                    <h6 class="bx" 
                                        :class="{'bx-minus': activeTheme === 'background' && !collapseBackgroundImage, 'bx-plus': activeTheme !== 'background' || collapseBackgroundImage, 'bold-text': activeTheme === 'background' && !collapseBackgroundImage}" 
                                        @click="toggleThemes('background')">Backgrounds
                                    </h6>
                                </li>
                                </ul>
                                <ul class="thumbnail-list" v-if="!collapseBackgroundImage">
                                    <li v-for="image in images" :key="image.id">
                                    <img @click="change_bg('selected this image.', image)" :src="image.thumbnailUrl" class="thumbnail">
                                    </li>
                                </ul>

                                <hr class="theme-separator">

                                <ul>
                                    <li>
                                        <h6 class="bx" 
                                            :class="{'bx-minus': activeTheme === 'font' && !collapseFont, 'bx-plus': activeTheme !== 'font' || collapseFont, 'bold-text': activeTheme === 'font' && !collapseFont}" 
                                            @click="toggleThemes('font')">Fonts
                                        </h6>
                                    </li>
                                </ul>
                                <ul class="font-list" v-if="!collapseFont">                                    
                                    <li v-for="font in fonts" :key="font.id" @click="selectFont(font)" :style="{ fontFamily: font.name }">
                                        {{ font.name }}
                                    </li>
                                </ul>
                                
                                <hr class="theme-separator">
                                
                                <ul>
                                    <li>
                                        <h6 class="bx" 
                                            :class="{'bx-minus': activeTheme === 'lock' && !collapseLock, 'bx-plus': activeTheme !== 'lock' || collapseLock, 'bold-text': activeTheme === 'lock' && !collapseLock}" 
                                            @click="toggleThemes('lock')">Settings
                                        </h6>
                                    </li>
                                </ul>

                                <ul class="lock-list" v-if="!collapseLock">
                                    <li v-for="lock in locks" :key="lock.id" @click="call_lock(lock)">                                        
                                        <span v-if="!isLocked" class="bx bx-xsm bx-lock-open">  {{ lock.name }} </span>
                                        <div v-else class="bx bx-xsm bx-lock font-weight: bold;"> Locked </div>
                                    </li>
                                    
                                    <hr class="theme-separator">    
                                        <li @click="copyURL">
                                            <div class="bx bx-xsm bx-share"> Share </div>
                                        </li>
                                </ul>

                                <hr class="theme-separator">
                    </div>        
                </div> -->
                <div style="text-align: center;">
                        <div>
                            <p style="font-size: x-large">{{ this.wbtitle }}</p>
                        </div>

                        <div>
                            <p style="font-size: large">{{ this.wbrecipient }}</p>
                        </div>


                    <div class="icon-container">
                        <!-- <i v-if="!isLocked" id="add" v-on:click="add_wish('Form cannot be submitted yet.', $event)" class='bx bx-plus bx-tada-hover bx-md' title="Add a Wish!"></i>                     -->
                        <!-- <i v-if="allowEdit && !isLocked" v-on:click="call_sidebar('Form cannot be submitted yet.', $event)" id="edit"  class='bx bx-wrench bx-md' title="Change Background or Fonts"></i>  -->
                        <!-- <i  v-if="allowEdit && !isLocked" v-on:click="call_lock('Calling unlocked code.', $event)" id="lock"  class='bx bx-lock-open bx-md' title="Wishes can be added"></i> -->
                        <!-- <i  v-if="allowEdit && isLocked" v-on:click="call_lock('Calling locked code.', $event)" id="locked"  class='bx bx-lock bx-md' title="Wishes cannot be added. Click again to allow Wishes to be added."></i> -->
                        <!-- <ShareButton /> -->
                    </div>
                </div>
            </div>
                <!-- <div>
                    <div id="bg" class="cards" :style="{ 'background-image': backgroundImage }">
                        <div v-for="wish in wishes" :key="wish.id" class="wishcard" >
                            From: {{ wish.wisher_name }} <br>
                            {{ wish.wisher_message }} <br>
                            <img class="displayed" v-bind:src= "wish.wish_image_url">
                        </div>
                    </div>
                </div>       -->
        </div>
    </div>
    </div>
</template>

<script>
// import axios from 'axios';
import { toast } from 'bulma-toast';
import axios from '../axiosConfig';
import ShareButton from "@/components/ShareButton.vue"; // Adjust the path based on your project structure


export default {
    // components: {
    //     ShareButton,
    // },
        name: 'Demo',
        props: {
        showNavbar: {
            type: Boolean,
            default: false,
        },
    },
    data () {
        return {
            images:[
                // images data
            ],
            fonts: [
                // fonts data
            ],
            locks: [
                // locks data
            ],
            share : [
                // share data
            ],
            selectedFont: null,
            wishes:[],
            backgroundImage: '',
            wbid: '',
            wbtitle: '',
            wbrecipient: '',
            allowEdit: false,
            showSidebar: false,
            isLocked: false,
            collapseBackgroundImage: true,
            collapseFont: true,
            collapseLock: true,
            activeTheme: '',
        }
    },
    computed: {
    fontFamilyStyle() {
        return {
                fontFamily: this.selectedFont ? this.selectedFont.name : 'Sofia',
            };
        },
    },



    methods: {
                toggle_wish(wish){
                    wish.selected = !wish.selected;
                },
                delete_wish(wish) {
                    // Construct the URL for the delete message API endpoint
                    const url = `/mywishboard/api/wishboard/${this.wbid}/message/${wish.id}/delete/`;

                    // Make the API request to delete the message
                    axios.delete(url, {
                        headers: {
                            'Authorization': 'Bearer ' + this.$store.getters.getGToken,
                        }
                    })
                    .then(response => {
                        // Handle successful deletion
                        console.log('Message deleted successfully:', response.data);

                        // Remove the wish from the wishes array
                        const index = this.wishes.indexOf(wish);
                        if (index !== -1) {
                            this.wishes.splice(index, 1);
                        }
                    })
                    .catch(error => {
                        // Handle errors
                        console.error('Error deleting message:', error);
                    });
                },
                validate_tok() {
                    // console.log("validate token in wishboard vue");
                    var url = "/mywishboard/api/wishboard/user/token/verify/";
                    // var url = "http://localhost:8000/mywishboard/api/wishboard/user/token/verify/"; dev enable; prod disable
                    
                    axios.post(url, {}, {
                        headers: {
                            'Authorization': 'Bearer ' + this.$store.getters.getGToken,
                        }
                    })
                    .then((response) => {
                        if (response.data && response.data.success === 'Token is available') {
                            console.log("Token is available");
                            // Handle the case where the token is available
                        } else if (response.data && response.data.error === 'Token expired') {
                            console.log("Token expired error");
                            this.$router.push("/login");
                            // Handle the case where the token is expired
                        } else if (response.data && response.data.error === 'User or Token error') {
                            console.log("User or Token error");
                            this.$router.push("/login");
                            // Handle the case where there is a user or token error
                        } else {
                            // Handle other cases or do nothing
                            
                        }
                    })
                    .catch((error) => {
                        this.$router.push("/login");
                        console.error("Error:", error);
                        // Handle other errors if needed
                    });

                },
            async handleVisibilityChange() {
                if (document.visibilityState === 'visible') {
                    // Page is visible, check authentication status and take appropriate action
                     this.validate_tok();
                }
            },


            copyURL() {
                const urlToCopy = window.location.href;
                this.copyToClipboard(urlToCopy);
                this.showToast("URL copied to clipboard! Share it with your friends");
                },
            copyToClipboard(text) {
                const textarea = document.createElement("textarea");
                textarea.value = text;
                textarea.style.position = "fixed";
                textarea.style.opacity = 0;
                document.body.appendChild(textarea);
                textarea.select();
                document.execCommand("copy");
                document.body.removeChild(textarea);
                },
            showToast(message) {
                toast({
                    message: message,
                    type: 'is-success',
                    position: 'top-center',
                    duration: 3000,
                    dismissible: true,
                    pauseOnHover: true,
                });
            },
  

    async loadImage(image) {
        let thumbnail, original;
        thumbnail = image.thumbnailUrl; // static images
        original = (await image.original()).default; // dynamic images
        return { thumbnail, original };
    },
        toggleThemes(theme){
            if (this.activeTheme === theme) {
                this.activeTheme = ''; // Collapse the clicked theme if it's already active
            } else {
                this.activeTheme = theme; // Otherwise, set it as the active theme
            }

            this.collapseBackgroundImage = this.activeTheme !== 'background';
            this.collapseFont = this.activeTheme !== 'font';
            this.collapseLock = this.activeTheme !== 'lock';
            },

        shuffleImages() {
            // Fisher-Yates shuffle algorithm
            for (let i = this.images.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1));
                [this.images[i], this.images[j]] = [this.images[j], this.images[i]];
            }
        },

        call_lock(status){
            this.isLocked = !this.isLocked
            axios.post('/mywishboard/api/wishboard/usersettings/' + this.wbid + '/lock/',
              {
                  'user': this.$store.getters.getUser,
                  'is_locked': this.isLocked,
              },
              {
                    headers: { 
                        'Authorization': 'Bearer ' + this.$store.getters.getGToken,
                    }
              })
            
        },
          toggleSidebar() {
            this.showSidebar = !this.showSidebar;
        },
          selectFont(font) {
            this.selectedFont = font;
              axios.post('/mywishboard/api/wishboard/usersettings/' + this.wbid + '/',
              {
                  'font_name': this.selectedFont.name,
              },
              {
                    headers: { 
                        'Authorization': 'Bearer ' + this.$store.getters.getGToken,
                    }
              })
        },

        call_sidebar: function (message, event){
            this.showSidebar = !this.showSidebar;
            this.shuffleImages();
        },

        async change_bg(message, image) {
            const { thumbnail, original } = await this.loadImage(image);
            this.backgroundImage = `url(${original})`;
    
            //   this.backgroundImage = 'url(https://cdn.pixabay.com/photo/2017/10/25/08/25/cupcakes-2887270_1280.jpg)';
            
            axios.post('/mywishboard/api/wishboard/usersettings/' + this.wbid + '/',
            {
                'font_name': this.selectedFont.name,
                ...(this.backgroundImage && { 'background_url': this.backgroundImage }),
            },
            {
                headers: { 
                    'Authorization': 'Bearer ' + this.$store.getters.getGToken,
                }
            })
          },


        fetch(wishboard_id) {
            axios.get('/mywishboard/api/wishlist/?wishboard_id=' + wishboard_id)
            .then((response) => {
                this.wishes = response.data;
            })
            .catch(err => console.log(err));
        }
        
    },
        
    // mounted() {

    //         this.emitter.on('validateTokEvent', this.validate_tok);
    
    //         document.addEventListener('visibilitychange', this.handleVisibilityChange);
    //         document.addEventListener('click', this.handleOutsideClick);

    //         this.emitter.emit('showlogout', 'true');
    //         this.emitter.emit('showWishboardCreate', 'true');
    //         this.emitter.emit('showWishboardList', 'true');

    //         // Get a random index within the range of the images array length
    //         // const randomIndex = Math.floor(Math.random() * this.images.length);
    //         // this.backgroundImage = this.images[randomIndex];

    //         var wbid = this.$store.state.wishboard_id_vue;
    //         wbid = this.$route.query.wishboard_id;
    //         this.wbid = wbid;
    //         this.fetch(wbid);
    //         var listorg = this.wishes;
    //         this.wishes = listorg.map((review) => {
    //             return {
    //                 wisher_name: review.wisher_name,
    //                 wisher_message: review.wisher_message,
    //                 wish_image_url: review.wish_image_url,
    //                 wish_message_date: review.wish_message_date
    //             };
    //         });             


    //             axios.post('/mywishboard/api/wishboard/metadetails/get/',
    //                 {
    //                     'wbid': wbid
    //                 },
    //                 {
    //                     headers: { 
    //                         'Authorization': 'Bearer ' + this.$store.getters.getGToken,
    //                     }
    //                 })
    //                 .then((response) => {
    //                     if(response.status >= 200){
    //                         this.wbtitle = response.data["wb_title"]
    //                         this.wbrecipient = response.data["wb_recipient"]
    //                     }
    //                 })




    //                 axios.get('/mywishboard/api/wishboard/usersettings/' + wbid +'/get/',
    //                 {
    //                     headers: { 
    //                         'Authorization': 'Bearer ' + this.$store.getters.getGToken,
    //                     }
                
    //                 })
    //                 .then((response) => {
    //                     if(response.status == 200){
    //                         this.backgroundImage = response.data["wishboard_background_url"];
    //                         const retrievedFontName = response.data["wishboard_font_name"];
    //                         this.selectedFont  = {name : retrievedFontName}
    //                     }else{
    //                         this.backgroundImage = 'url(https://cdn.pixabay.com/photo/2017/10/25/08/25/cupcakes-2887270_1280.jpg)';
    //                     }
    //                 });                


    //                 axios.post('/mywishboard/api/wishboard/usersettings/' + wbid +'/validate/',
    //                 {
    //                     'user':this.$store.getters.getUser
    //                 },
    //                 {
    //                     headers: { 
    //                         'Authorization': 'Bearer ' + this.$store.getters.getGToken,
    //                     }
                
    //                 })
    //                 .then((response) => {
    //                     if(response.status == 200){
    //                         if(response.data["wishboard_created_by_logged_user"] == true)
    //                             this.allowEdit = true;
    //                         else
    //                             this.allowEdit = false;
    //                     }else{
    //                         this.allowEdit = false;
    //                     }
    //                 });                

    //                 // check for locked board status

    //                 axios.get('/mywishboard/api/wishboard/usersettings/' + wbid +'/lockstatus/',
    //                 {
    //                     'user':this.$store.getters.getUser
    //                 },
    //                 {
    //                     headers: { 
    //                         'Authorization': 'Bearer ' + this.$store.getters.getGToken,
    //                     }
    //                 })
    //                 .then((response) => {
    //                     if(response.status == 200){
    //                         if(response.data["is_locked"] == true)
    //                             this.isLocked = true;
    //                         else
    //                             this.isLocked = false;
    //                     }
    //                 });                
 
    //         }
}
</script>
